import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useGetCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useGetCertificadoEmpresaItByID';
import { jwtDecode } from 'jwt-decode';
import useDecode from 'hooks/useDecode';
import PagoUnicoCATA from './PagoUnicoCATA';
import useGetPagoUnicoCATAByID from 'services/record/PagoUnicoCATA/useGetPagoUnicoCATAByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialPagoUnicoCATA = () => {
    const decoded = useDecode("token");
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetPagoUnicoCATAByID, errorGetPagoUnicoCATAByID, loadingGetPagoUnicoCATAByID, getPagoUnicoCATAByID, successGetPagoUnicoCATAByID } = useGetPagoUnicoCATAByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const userId = decoded.extension_id;
            const prestacionId = idprestacion.split('_')[1];
            const formId = idform;

            getPagoUnicoCATAByID(userId, prestacionId, formId, setData);
        }
    }, []);

    return (
        <div>
            <PageMenu title={'Pago único en cese de actividad en autónomos'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetPagoUnicoCATAByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <PagoUnicoCATA dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialPagoUnicoCATA